import api from '../../api'
import { FETCH_DP_URL } from '../mutations/available'

export function fetchDPUrlActions ({commit}) {
  api.getSettings()
    .then(res => {
      if (res !== null && res !== 'undefined') {
        commit(FETCH_DP_URL, res)
      } else {
        commit(FETCH_DP_URL, 'http://app.dpathology.ru/')
      }
    })
}



// WEBPACK FOOTER //
// ./src/store/actions/fetchDPUrl.js